export default "<div>\n    <mat-slide-toggle [checked]=\"checked\" (change)=\"toggle($event)\">{{description}}</mat-slide-toggle>\n</div>";